const {
  runStringExtender: baseRunStringExtender
} = require('vue-js-extender');

const _jsExtensionCache = {
  String: {
    replaceTypes: ["string", "regexp"],
    toEscapeChars: ['.', '?', '|']
  }
};

exports.runStringExtender = (Vue) => {
  baseRunStringExtender(Vue);

  //------------------------- String Extensions -------------------------
  //------------------------- End -------------------------
};



// WEBPACK FOOTER //
// ./src/core/js-extender/string.extender.js